import React from 'react';
import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SectionCard from './SectionCard';
import EmptyState from './EmptyState';
import ErrorState from './ErrorState';
import LoadingState from './LoadingState';

export default function DataTableShell({
  title,
  subtitle,
  actions,
  loading = false,
  error,
  empty,
  children,
  mobileCards,
  onRetry,
  tone = 'dashboard',
  sx,
}) {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <SectionCard title={title} subheader={subtitle} action={actions} tone={tone} sx={sx}>
      {loading ? (
        <LoadingState rows={6} header={false} />
      ) : error ? (
        <ErrorState compact title="Unable to load data" description={error} onRetry={onRetry} />
      ) : empty ? (
        typeof empty === 'string' ? (
          <EmptyState compact title={empty} />
        ) : (
          empty
        )
      ) : (
        <Box>
          {mdUp || !mobileCards ? children : mobileCards}
        </Box>
      )}
      {!mdUp && mobileCards && children ? (
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Swipe and scroll for full details on larger view.
          </Typography>
        </Stack>
      ) : null}
      {!mdUp && !mobileCards && children ? (
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
          <Button size="small" variant="text" sx={{ pointerEvents: 'none' }}>
            Desktop table view
          </Button>
        </Stack>
      ) : null}
    </SectionCard>
  );
}

